module.exports = "/images/Booking_Steps_Banner.jpg?2a0b19a3d5fe956ca8aa422a6f38cd9f";